import { MMButton, SelectAccount } from '@components'
import { PaymentMethods, useWalletPayment } from 'mmfintech-checkout-commons'
import { tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { type FormEvent, useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import './SelectAccountPane.scss'

const SelectAccountPane = ({ selectedAccount, setSelectedAccount, onSuccess, onCancel }) => {
  const { session, walletAccounts, walletAccountsError, walletPreviewError, walletPreviewFetching } = useSelector(
    ({ checkout: { session, walletAccounts, walletAccountsError, walletPreviewError, walletPreviewFetching } }) => ({
      session,
      walletAccounts,
      walletAccountsError,
      walletPreviewError,
      walletPreviewFetching
    }),
    shallowEqual
  )

  const { fetchAccounts, walletPaymentPreview } = useWalletPayment()

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (selectedAccount) {
      walletPaymentPreview(selectedAccount.id, PaymentMethods.JETON_BANK_WALLET, onSuccess)
    }
  }

  useEffect(() => {
    if (session) {
      void fetchAccounts(session.currency)
    }
  }, [session])

  return (
    <div className='payment-container'>
      <form className='select-account-pane-wrapper' noValidate onSubmit={handleSubmit}>
        <div className='account-title'>{tr('CHECKOUT.WALLET_PAYMENT.TITLE', 'Pay with wallet')}</div>

        <SelectAccount
          label={tr('CHECKOUT.WALLET_PAYMENT.ACCOUNT', 'Account')}
          selectedAccount={selectedAccount}
          setSelectedAccount={setSelectedAccount}
          accounts={walletAccounts}
        />

        <ErrorDisplay error={[walletAccountsError, walletPreviewError]} />

        <div className='form-actions'>
          <MMButton
            type='submit'
            variant='primary'
            caption={tr('CHECKOUT.BUTTONS.CONTINUE', 'Continue')}
            loading={walletPreviewFetching}
            disabled={!selectedAccount}
            data-test='button-submit'
            fullWidth
          />
          <MMButton
            type='button'
            variant='secondary'
            caption={tr('CHECKOUT.BUTTONS.BACK', 'Back')}
            onClick={onCancel}
            disabled={walletPreviewFetching}
            data-test='button-back'
            fullWidth
          />
        </div>
      </form>
    </div>
  )
}

export default SelectAccountPane
